"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAuthValidationUrl = parseAuthValidationUrl;
exports.parseValidationParamsFromSearch = parseValidationParamsFromSearch;
exports.parsePasswordResetUrl = parsePasswordResetUrl;
exports.parseResetParamsFromSearch = parseResetParamsFromSearch;
function parsePositiveInt(raw) {
    if (!raw)
        return 0;
    const digits = raw.replace(/\D/g, '');
    const n = parseInt(digits, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
}
function is4pdaHost(hostname) {
    const host = hostname.toLowerCase();
    return host.endsWith('4pda.ru') || host.endsWith('4pda.to');
}
function isAuthUrl(pathname, params) {
    const path = pathname.replace(/\/+$/, '').toLowerCase();
    if (path.endsWith('/auth') || path === '/auth')
        return true;
    if (params.get('act')?.toLowerCase() === 'auth')
        return true;
    return false;
}
function resolveKind(type, action) {
    const normalizedType = type.toLowerCase();
    if (normalizedType === 'reg')
        return 'reg';
    if (normalizedType === 'lostpass')
        return 'lostpass';
    if (normalizedType === 'newemail')
        return 'newemail';
    if (normalizedType === 'email' || normalizedType === 'cemail')
        return 'newemail';
    const normalizedAction = action.toLowerCase();
    if (normalizedAction === 'lostpass' || normalizedAction === 'lostpass-2') {
        return 'lostpass';
    }
    return null;
}
function parseValidationParams(params) {
    const action = (params.get('action') || '').toLowerCase();
    const type = (params.get('type') || '').toLowerCase();
    const kind = resolveKind(type, action);
    if (!kind)
        return null;
    const memberId = parsePositiveInt(params.get('m'));
    const timestamp = parsePositiveInt(params.get('t'));
    const sig = (params.get('s') || '').trim();
    if (memberId <= 0 || timestamp <= 0 || !sig)
        return null;
    if (kind === 'newemail') {
        const rawEmail = params.get('p');
        if (!rawEmail?.trim())
            return null;
        let newEmail;
        try {
            newEmail = decodeURIComponent(rawEmail.trim());
        }
        catch {
            newEmail = rawEmail.trim();
        }
        if (!newEmail)
            return null;
        return { kind, memberId, timestamp, sig, newEmail };
    }
    return { kind, memberId, timestamp, sig };
}
/**
 * Разбор deeplink из письма (активация, сброс пароля, подтверждение e-mail).
 *
 * Активация: `…&act=auth&action=validate&m=…&t=…&type=reg&s=…`
 * Сброс: `…&type=lostpass&s=…` (или `action=lostpass`)
 * Смена e-mail: `…&type=newemail&p=<newEmail>&m=&t=&s=` → `mu(3, m, t, s, p)`; нужна авторизация
 */
function parseAuthValidationUrl(url) {
    if (!url?.trim())
        return null;
    try {
        const parsed = new URL(url, 'https://4pda.to');
        if (!is4pdaHost(parsed.hostname))
            return null;
        if (!isAuthUrl(parsed.pathname, parsed.searchParams))
            return null;
        return parseValidationParams(parsed.searchParams);
    }
    catch {
        return null;
    }
}
/** @internal Экспорт для unit-тестов и nextpda-web (localhost). */
function parseValidationParamsFromSearch(search) {
    if (!search)
        return null;
    const raw = search.startsWith('?') ? search.slice(1) : search;
    return parseValidationParams(new URLSearchParams(raw));
}
/** Совместимость со старым API сброса пароля. */
function parsePasswordResetUrl(url) {
    const parsed = parseAuthValidationUrl(url);
    if (!parsed || parsed.kind !== 'lostpass')
        return null;
    return {
        memberId: parsed.memberId,
        timestamp: parsed.timestamp,
        sig: parsed.sig,
    };
}
/** @internal */
function parseResetParamsFromSearch(search) {
    const parsed = parseValidationParamsFromSearch(search);
    if (!parsed || parsed.kind !== 'lostpass')
        return null;
    return {
        memberId: parsed.memberId,
        timestamp: parsed.timestamp,
        sig: parsed.sig,
    };
}
